module.exports = __webpack_public_path__ + "img/Phone_02.4e21804b.jpg";